// extracted by mini-css-extract-plugin
module.exports = {"spinnerOut":"styles_spinnerOut__CtKGz","spinnerIn":"styles_spinnerIn__NtIZ7"};